/**
 * Created by neo on 19.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { RecipeInstructionStep, createRecipeInstructionStep } from './RecipeInstructionStep';
import { LocalizedValue, createLocalizedValue } from '../../LocalizedValue';

export type RecipeInstruction = {
  name: LocalizedValue[];
  steps: RecipeInstructionStep[];
};

export function createRecipeInstruction(json?: Partial<RecipeInstruction>): RecipeInstruction {
  return makeAutoObservable({
    name: (json?.name ?? []).map((l: any) => createLocalizedValue(l)),
    steps: (json?.steps ?? []).map((s: any) => createRecipeInstructionStep(s)),
  });
}
